import React from "react";
import clsx from "clsx";

interface GlowingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "cyan" | "magenta" | "blue";
  children: React.ReactNode;
}

export function GlowingButton({ variant = "cyan", children, className, ...props }: GlowingButtonProps) {
  const colorMap = {
    cyan: "text-neon-cyan border-neon-cyan shadow-[0_0_15px_rgba(0,243,255,0.3)] hover:shadow-[0_0_30px_rgba(0,243,255,0.6)] hover:bg-neon-cyan",
    magenta: "text-neon-magenta border-neon-magenta shadow-[0_0_15px_rgba(255,0,255,0.3)] hover:shadow-[0_0_30px_rgba(255,0,255,0.6)] hover:bg-neon-magenta",
    blue: "text-neon-blue border-neon-blue shadow-[0_0_15px_rgba(0,102,255,0.3)] hover:shadow-[0_0_30px_rgba(0,102,255,0.6)] hover:bg-neon-blue",
  };

  return (
    <button
      className={clsx(
        "relative px-8 py-3 border bg-black/30 backdrop-blur-sm hover:text-white font-bold uppercase tracking-widest transition-all duration-300 overflow-hidden group",
        colorMap[variant],
        className
      )}
      {...props}
    >
      <span className="relative z-10 drop-shadow-[0_2px_2px_rgba(0,0,0,0.8)]">{children}</span>
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out z-0"></div>
    </button>
  );
}
